import { Owned } from 'app/model/base/named';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from 'app/model/linkedservice/linkedservice';
import { Named, ConnectionKind, isLogicAppExpression, SharedModel} from 'shell-models-lib';
import { generateUUID } from 'app/shared/utils/uuid.util';
import { iFrameCustomerProfiles, IFrameProfile } from 'app/services/iframe-customer-profiles';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { CustomActivity } from '../pipeline/custom.activity';
import { GlobalVariables } from 'app/services/globals';

    export function getFabricLsForParameterizedConnections(
        linkedServiceName: SharedModel.LinkedServiceReference,
        linkedServiceType:string,
        activity: Named) : LinkedService | undefined {
          const lsModel = Metamodel.modelByName(linkedServiceType);
          const templateLinkedService = Owned.create<LinkedService>(lsModel, activity);
          const lsref = (linkedServiceName as SharedModel.LinkedServiceReference);
          if (isConnectionParameterizationEnabled(activity) && isLogicAppExpression(lsref?.referenceName)) {
                  templateLinkedService.name = generateUUID().replaceAll('-', '_');
                  ValueAdapter.toModel(
                      templateLinkedService,
                      Metamodel.modelByName(linkedServiceType).attribute('objectId'),
                      lsref.referenceName
                  );
                  templateLinkedService.tridentArtifactType = templateLinkedService.tridentArtifactType ?? 'Connection';
                  templateLinkedService.tridentConnectionKind = (iFrameCustomerProfiles[IFrameProfile.TridentWorkspace]
                      .linkedServiceToConnectionTypeMapping[linkedServiceType] || linkedServiceType) as ConnectionKind;
                  templateLinkedService.parameterized = true;
                  return templateLinkedService;
              }
          return undefined;
      }
      
    export function isUrlValid(url: string): boolean {
        try {
            new URL(url);
            return true;
        } catch (e) {
            return false;
        }
    }
    
    function isConnectionParameterizationEnabled(activity: Named): boolean {
        if (!__IS_FABRIC_DPE__) {
            return false;
        }
        return activity instanceof CustomActivity
            ? GlobalVariables.enableConnectionParamForAzBatch
            : GlobalVariables.enableAllConnectionParamForExternalActivities;
    }
